import { connect } from 'react-redux';

import SecondHandBoardgamePageComponent from '../components/SecondHandBoardgamePage';

import { isLoadingSelector } from '../reducers';
import { boardgameSelector } from '../reducers/secondHandBoardgames';

import { getSecondHandBoardgame } from '../actions/secondHandBoardgames';
import { changeHeaderType } from '../actions/navigation';

const mapStateToProps = (state, ownProps) => {
  return {
    boardgame: boardgameSelector(state)(ownProps.match.params.id),
    loading: isLoadingSelector(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeHeaderType: (type) => dispatch(changeHeaderType(type)),
    getBoardgame: (id) => dispatch(getSecondHandBoardgame(id)),
  };
};

const SecondHandBoardgamePage = connect(mapStateToProps, mapDispatchToProps)(SecondHandBoardgamePageComponent);

export default SecondHandBoardgamePage;
